
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dog-widget",
      function () {
        return require("private-next-pages/dog-widget.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dog-widget"])
      });
    }
  